import React, {Fragment} from "react";
import Widget from "../../components/BetterWidget";
import {Button, CircularProgress, Grid, MenuItem, TextField, Typography} from "@material-ui/core";
import Rest from "../../helpers/Rest";

export class SiteReport extends React.Component{
    constructor(props) {
        super(props);
        const customer = this.props.customers.list.find(customer => customer.sites.length > 0)
        if (customer){
            this.state = {
                customer: customer.id,
                site: customer.sites[0].id,
                generating: false
            }
        }
    }

    setCustomer(e){
        const id = e.target.value
        const customer = this.props.customers.map[id]
        this.setState({
            customer: id,
            site: customer.sites[0].id
        })
    }

    setSite(e){
        this.setState({
            site: e.target.value
        })
    }

    save() {
        const {site, customer} = this.state
        this.setState({generating: true})
        const siteObj = this.props.customers.map[customer].sites.find(item => item.id = site)
        Rest.getCsv("report/zone/" + site, `${siteObj.name.replace(/\s+/g, '-')}-report.csv`).then(() => {
            this.setState({generating: false})
        })
    }

    button(){
        return (
            <Button
                variant="contained"
                color="primary"
                onClick={this.save.bind(this)}
            >
                Save Report
            </Button>
        )
    }

    progress(){
        return (
            <Fragment>
                Generating report...<CircularProgress color="primary"/>
            </Fragment>
        )
    }

    render(){
        if (!this.state){
            return "No sites available"
        }
        const {customer, site, generating} = this.state
        const customers = this.props.customers
        return (
            <Widget>
                <Grid container spacing={2} className={this.props.className}>
                    <Grid item xs={12}>
                        <Typography variant="h3">Site Report</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            variant="outlined"
                            label="Customer"
                            value={customer}
                            onChange={this.setCustomer.bind(this)}
                            fullWidth
                            select
                        >
                            {customers.list.filter(customer => customer.sites.length > 0).map(customer => (
                                <MenuItem key={customer.id} value={customer.id}>
                                    {customer.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            variant="outlined"
                            label="Site"
                            value={site}
                            onChange={this.setSite.bind(this)}
                            fullWidth
                            select
                        >
                            {customers.map[customer].sites.map(site => (
                                <MenuItem key={site.id} value={site.id}>
                                    {site.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid container item xs={12} justify="flex-end">
                        {generating ? this.progress() : this.button()}
                    </Grid>
                </Grid>
            </Widget>
        )
    }
}